// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2plC8","top":"styles_top__36ujj","left":"styles_left__1Iwt1","description":"styles_description__CaLlg"};